/*
 * @Author: luoguo
 * @Date: 2024-01-30 13:55:41
 * @LastEditTime: 2026-01-24 10:11:01
 * @LastEditors: zouning@szkingdom.com
 * @Description: httpClient, 5.0拦截器
 */
import Vue from "vue";
import axios from "axios";
import conf from "@/config/index";
import cache from "@/assets/js/cache";
import sign from "@/assets/js/sign";
import router from "@/router";
import store from "@/store/index";
import log from "@/assets/js/log";
import { openRequestLoading } from "@/assets/js/request_loading";

import urls from "@/api/urls";

let reqLoader = {};
let count = 0;
let timeoutAlertFlag = false; // 超时弹框标志。当页面由多个异步请求超时时，会弹出多个提示框影响体验。此标志用于判断是否已经有弹框，从而确保只有一次弹框。
// 检查重复请求,主要逻辑：
// 1，进入request拦截器后，调用removePending() 方法，检查在pending队列中是否存在跟当前请求相同的请求，如果有，调用前一个请求的f()方法进行取消
// 2, 将当前请求加入队列
// 3, 请求成功后，response拦截器同样调用removePending() 方法，将当前请求从pending中移除
let pending = [];
let CancelToken = axios.CancelToken;
let removePending = (config) => {
    for (let p in pending) {
        if ((config.url + "&" + config.method).indexOf(pending[p].u) > -1 && !config.repeat) {
            if (reqLoader[pending[p]._loader]) {
                reqLoader[pending[p]._loader].close();
            }
            pending[p].f();
            pending.splice(p, 1);
        }
    }
};
const clearPending = () => {
    for (let p in pending) {
        if (reqLoader[pending[p]._loader]) {
            reqLoader[pending[p]._loader].close();
        }
        pending[p].f();
        pending.splice(p, 1);
        clearPending();
        break;
    }
};

const instance = axios.create();

// 记录重复请求 ends
instance.defaults.timeout = 30000;
instance.defaults.baseURL = conf.api.v5BaseUrl;

// 添加请求拦截器
instance.interceptors.request.use(
    function (config) {
        // 在发送请求之前
        // 组织公参
        const _x = sign.uuid();

        config.headers = Object.assign(
            { Accept: "application/json, text/plain, */*" },
            config.headers
        );

        config.headers.index = sign.uuid();
        config.headers.secretId = conf.secretId;
        config.headers.deviceType = conf.deviceType;
        config.headers.tenantid = "0001";

        if (config.url.indexOf(urls.baseOrdinary2Professional) != -1) {
            // 投资者类型普通转专业
            config.headers.menuid = "410504200";
            config.headers.userid = "0000";
            config.headers.action = "A";
        }

        // 附带鉴权的token
        const session = {
            token: cache.getSessionToken(),
            key: cache.getSessionKey()
        };
        if (session && session.token) {
            config.headers.token = (session && session.token) || "";
        }

        // 判断是否为 FormData 类型请求（文件上传）
        if (config.data instanceof FormData) {
            //  对于 FormData，直接使用原始数据，不包裹 head/body
            // （此时 config.data 就是 FormData 对象，无需修改）
        } else {
            // 非 FormData 请求（普通 JSON 请求），继续使用原有的 head/body 包裹逻辑
            // body相关处理
            let body = {};
            if (config.url.indexOf(urls.login) != -1) {
                body = {
                    head: {
                        systemtype: conf.systemtype,
                        // token: token
                        acceptmethod: conf.systemtype
                    },
                    loginsystemtype: conf.systemtype,
                    logintoken: session.token || "",
                    ...config.data
                };
            } else {
                const paths = config.url.split("/");
                body = {
                    head: {
                        func_id: paths[paths.length - 1],
                        systemtype: conf.systemtype,
                        acceptmethod: conf.systemtype,
                        mac: "",
                        imei: "",
                        uuid: ""
                        // token: token
                    },
                    body: {
                        // systemtype: conf.systemtype,
                        ...config.data
                    }
                };
            }

            config.data = body;
        }

        // 异步调用原生方法获取每个请求的sign值
        // 组织公参 ends
        // 检查重复请求
        removePending(config);
        // 将当前请求加入pending队列
        config.cancelToken = new CancelToken((c) => {
            pending.push({
                u: config.url + "&" + config.method,
                f: c,
                _loader: config._loader
            });
        });
        log.trace("[" + config.url + "] 的详细请求参数: ", config);
        return config;
    },
    function (error) {
        // 请求错误
        log.fatal("发送请求错误: ", error);
        // reqLoader.close()
        return Promise.reject(error);
    }
);

// 添加响应拦截器
instance.interceptors.response.use(
    function (response) {
        // 服务端响应后
        // 从pending队列中移除当前请求
        removePending(response.config);
        if (response.config.waiting_tip === -1) {
            if (response.config._loader) {
                reqLoader[response.config._loader].close();
            }
        }
        // 	鉴权申请流水号存起来 后续别的接口入参调用
        if (response.config.url.includes("api/authSend") && response) {
            const bankgateSerialNo = response.data.body.bankgateserialno || "";
            sessionStorage.setItem("bankgateserialno", bankgateSerialNo);
        }

        let data = response.data;
        // 针对文件下载返回文件流
        if (response.request.responseType === "arraybuffer") {
            let datas = {
                alllength: "1",
                code: "0000000",
                msg: "下载内容",
                record: [response.data]
            };
            return {
                data: datas
            };
        }
        let code = data.code;
        log.info("服务端返回: ", data);
        let d3 = code.charAt(2);

        let valid = false;
        if (typeof response.config.validateCode === "boolean") {
            valid = response.config.validateCode;
        } else if (typeof response.config.validateCode === "function") {
            valid = response.config.validateCode(response.data.code);
        }

        if (valid) {
            // 如果是发短信验证码接口，或登录接口
            if (
                response.config.url.indexOf(urls.identifyVerification) != -1 ||
                response.config.url.indexOf(urls.dict) != -1 ||
                response.config.url.indexOf(urls.loginSms) != -1 ||
                response.config.url.indexOf(urls.login) != -1 ||
                response.config.url.indexOf(urls.sendSms) != -1 ||
                (response.config.url.indexOf(urls.getAuthCode) != -1 &&
                    cache.getSysParam("10103010") == "1" &&
                    !store.state.login.status)
            ) {
                sessionStorage.setItem(
                    "_a",
                    JSON.stringify({
                        token: response.headers.token || ""
                    })
                );
            }

            // 接口返回成功，此时将数据传递到页面
            return { data: data.body, ...data };
        } else if (code === "9999999") {
            // 接口超时，此时应清空所有还未发出的请求，以免重复报超时
            clearPending();
            // 接口返回超时，此时有两种情况：
            // 之前已登录，此时应通知框架更新登录状态为未登录，跳到login页面，并提示用户
            if (!timeoutAlertFlag) {
                timeoutAlertFlag = true;
                const _sessionData = "";
                store.dispatch("logout", _sessionData).then((res) => {
                    Vue.prototype
                        .$alert(
                            "您尚未登录，或已长时间未进行操作，为了保障您的账户安全，请刷新后重新登录!",
                            "",
                            {
                                confirmButtonText: "确定",
                                type: "warning",
                                callback: (action) => {
                                    sessionStorage.removeItem("_a");
                                    timeoutAlertFlag = false;
                                    router.push("/");
                                }
                            }
                        )
                        .then(() => {
                            return false;
                        })
                        .catch(() => {
                            return false;
                        });
                });
            }
            return Promise.reject(data);
        } else if (code === "9999998") {
            // 账号在别处登录。这种情况应该只出现在DAC应用中，DB记录的用户状态被删除导致，其他未使用JDAC的应用如终端系统不应该出现此情况
            clearPending();
            if (!timeoutAlertFlag) {
                timeoutAlertFlag = true;
                Vue.prototype
                    .$alert("您的账号可能已经在别处登录，请重新登录!", "", {
                        confirmButtonText: "确定",
                        type: "warning",
                        callback: (action) => {
                            timeoutAlertFlag = false;
                            sessionStorage.removeItem("_a");
                            store.dispatch("logout").then((res) => {
                                router.push("/");
                            });
                        }
                    })
                    .then(() => {
                        return false;
                    })
                    .catch(() => {
                        return false;
                    });
            }
        } else if (
            response.config.url.indexOf(urls.sdxCheck) != -1 &&
            (code === "-990001" || code === "00080005" || code === "00080015")
        ) {
            // [客户未进行资产类型为[2-公募]的风险测评,请检查]
            let msg = data.msg;
            let assetType = "";
            let assetName = "";
            if (code === "-990001") {
                const match = msg.match(/资产类型为\[(\d+)-(.*?)\]/);
                if (match) {
                    assetType = match[1];
                    assetName = match[2];
                    msg = `您还未完成${assetName}风险评测，无法进行该产品的交易。`;
                } else if (msg.indexOf("资产类型为") !== -1) {
                    msg = `您还未完成风险评测，无法进行该产品的交易。`;
                }
            } else if (code === "00080005") {
                msg = `您还未完成风险评测，无法进行该产品的交易。`;
            } else if (code === "00080015") {
                msg = `您风险测评已过期，无法进行该产品的交易。`;
            }

            Vue.prototype
                .$confirm(msg, "温馨提示", {
                    confirmButtonText: "去评测",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                .then(async () => {
                    let firstflag = "1";
                    try {
                        const custno = cache.getUser().custno;
                        if (custno) {
                            // 调用接口获取 checkRiskInfo
                            // eslint-disable-next-line no-use-before-define
                            const res = await new AxiosClass().post(urls.checkRiskInfo, {
                                custno: custno,
                                assettype: assetType || "*"
                            });
                            if (res && res.data) {
                                firstflag = res.data.firstriskdayflag || "1";
                            }
                        }
                    } catch (e) {
                        // ignore error, default to "1"
                    }
                    // const assetTypeFlag = Vue.prototype.$util.getParamValue("1000056");
                    if (assetType) {
                        router.push({
                            name: "risktest",
                            query: {
                                assettype: assetType,
                                firstriskdayflag: firstflag
                            }
                        });
                    } else {
                        router.push({
                            name: "risktest",
                            query: { firstriskdayflag: firstflag }
                        });
                    }
                })
                .catch(() => {});
            return Promise.reject(data);
        } else if (code === "-900020051") {
            // 对于特殊的返回，使用$alert提示
            let msg = data.msg;
            Vue.prototype.$alert(msg, "提示", {
                confirmButtonText: "确定"
            });
            return Promise.reject(new Error(data.msg));
        } else if (
            data.code === "100043" ||
            data.code === "100073" ||
            data.code === "100074" ||
            (Number(data.code) >= 100405 && Number(data.code) <= 100453)
        ) {
            sessionStorage.removeItem("_a");
            return Promise.reject(data);
        } else if (data.code === "01110006") {
            /* 交易密码过期 */
            Vue.prototype
                .$confirm(data.msg, "温馨提示", {
                    confirmButtonText: "前往修改",
                    cancelButtonText: "暂不修改",
                    type: "warning"
                })
                .then((action) => {
                    if (action === "confirm") {
                        router.push({ name: "changetpwd" });
                    }
                })
                .catch(() => {});
            return Promise.reject(data);
        } else if (code === "14010001") {
            Vue.prototype.$message.error(data.msg);
            return Promise.reject(data);
        } else if (code === "0130301") {
            /* 代销入口三要素验证，结果为直销客户 */
            return Promise.reject(data);
        } else {
            // 其他错误
            let msg = data.msg;
            if (msg.indexOf("黑名单") !== -1) {
                msg = cache.getCompanyInfoParam("10302001");
                // msg = "您的信息正在审核，通过后将及时与您联系，请您耐心等候!";
            }
            if (
                msg.indexOf("银行卡") !== -1 &&
                (msg.indexOf("未") !== -1 || msg.indexOf("没有") !== -1) &&
                (msg.indexOf("开通") !== -1 || msg.indexOf("办理") !== -1) &&
                msg.indexOf("无卡业务") !== -1
            ) {
                let msg =
                    "尊敬的客户，您的银行卡尚未开通无卡业务，您可以按照如下操作开通：下载云闪付APP客户端——注册用户名登陆（若已有注册用户名请直接登陆）——点击“我的卡包”-“添卡”（按照页面提示进行相应操作，勿跳过任何步骤）——点击“我的卡包”--“卡列表”点击已绑定银行卡，然后查看卡详情，若页面出现了实线框内在线支付，表示已开通；若是在线支付字样是灰色，则表示未开通，点击页面的开通在线支付去操作。";
                let html =
                    '<div style="text-align: justify" class="user-info-check"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>' +
                    msg +
                    "</div>";
                Vue.prototype.$alert(html, "支付失败", {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: "我已知晓",
                    customClass: "info-check"
                });
                return Promise.reject(new Error(data.msg));
            }
            Vue.prototype.$message.error(msg);
            return Promise.reject(new Error(data.msg));
        }
    },
    function (error) {
        console.log(444444, error, error.response);

        if (!axios.isCancel(error)) {
            clearPending();
        }
        if (error.response && error.response.status == 401) {
            if (!timeoutAlertFlag) {
                timeoutAlertFlag = true;
                const _sessionData = "";
                store.dispatch("logout", _sessionData).then((res) => {
                    Vue.prototype
                        .$alert(
                            error.response.data.code == "100047"
                                ? "您的账号已在其他地方登录，为了保障您的账户安全，请及时重新登录并修改密码！"
                                : "您尚未登录，或已长时间未进行操作，为了保障您的账户安全，请刷新后重新登录!",
                            {
                                confirmButtonText: "确定",
                                type: "warning",
                                callback: (action) => {
                                    sessionStorage.removeItem("_a");
                                    timeoutAlertFlag = false;
                                    router.push("/");
                                }
                            }
                        )
                        .then(() => {
                            return false;
                        })
                        .catch(() => {
                            return false;
                        });
                });
            }
            return Promise.reject(error);
        } else if (error.response && error.response.status == 429) {
            Vue.prototype.$message.error(error.response.data.msg);
            return Promise.reject(error);
        } else {
            // 响应错误
            log.fatal("请求响应错误: ", error);
            // reqLoader.close()
            let errMsg = error.message;
            if (error.toString() === "Cancel") {
                return Promise.reject(error);
            }
            if (errMsg && (errMsg.indexOf("network") !== -1 || errMsg.indexOf("timeout") !== -1)) {
                // 跳转网络错误页面
                router.push({ path: "/errNetwork" });
            } else {
                // 跳转统一致命错误提示页面
                // router.push({ path: "/errGeneral" });
                const msg =
                    (error && error.response && error.response.data && error.response.data.msg) ||
                    "系统繁忙，请稍后重试";
                Vue.prototype.$message.error(msg);
            }
            const loader = error.config && reqLoader[error.config._loader];
            if (error.config && error.config.waiting_tip === -1 && loader) {
                // 关闭loading效果
                loader.close();
            }
            // todo 调用日志接口通知服务端本次请求在前端发生错误
            return Promise.reject(error);
        }
    }
);

const defaultOption = {
    timeout: 30000,
    joinPrefix: true,
    urlPrefix: conf.api.v5BaseUrl,
    waiting_tip: -1,
    validateStatus: (status) => {
        return status >= 200 && status < 300;
    },
    validateCode: (code) => {
        return code === "0000000" || code === "0" || code === 0;
    }
};

class AxiosClass {
    get(url, params, option) {
        const config = {
            method: "GET",
            url: url,
            params: params
        };
        return this.request(config, option);
    }

    post(url, data, option) {
        const config = {
            method: "POST",
            url: url,
            data: data
        };
        return this.request(config, option);
    }

    put(url, data, option) {
        const config = {
            method: "PUT",
            url: url,
            data: data
        };
        return this.request(config, option);
    }

    patch(url, data, option) {
        const config = {
            method: "PATCH",
            url: url,
            data: data
        };
        return this.request(config, option);
    }

    delete(url, data, option) {
        const config = {
            method: "DELETE",
            url: url,
            data: data
        };
        return this.request(config, option);
    }

    request(config, option) {
        if (!option) {
            option = {};
        }
        const param = {
            ...config,
            timeout: option.timeout || defaultOption.timeout,
            headers: option.headers,
            validateStatus: option.validateStatus || defaultOption.validateStatus,
            validateCode: option.validateCode || defaultOption.validateCode,
            ...option.config
        };
        if (param.url === "/auth/remote/logout") {
            sessionStorage.removeItem("showImgCode");
        }
        if (option.joinPrefix === false) {
            param.baseURL = "";
        } else {
            param.baseURL = option.urlPrefix || defaultOption.urlPrefix;
        }
        if (option.waiting_tip !== undefined || option.waiting_tip) {
            param.waiting_tip = option.waiting_tip;
        } else {
            param.waiting_tip = defaultOption.waiting_tip;
        }
        if (param.waiting_tip === -1) {
            count++;
            if (param.loader || param.loader === undefined) {
                let loaderConf = {
                    lock: true,
                    text:
                        param.url.indexOf("/acct/ocr/upload") > -1
                            ? "loading（上传图片较大，请耐心等待）"
                            : "loading",
                    background: "rgba(255, 255, 255, 0.5)",
                    fullscreen: false
                };
                Object.assign(loaderConf, param.loader || {});
                if (loaderConf.target && loaderConf.background === "rgba(255, 255, 255, 0.5)") {
                    loaderConf.background = "rgba(255, 255, 255, 0.8)";
                }
                reqLoader[count] = openRequestLoading(loaderConf);
                param._loader = count;
            }
        }
        if (conf.session_mode === "1") {
            param.headers = Object.assign({}, param.headers || {}, {
                token: cache.getSessionToken(),
                g_systemtype: conf.systemtype,
                acceptmethod: conf.systemtype,
                systemtype: conf.systemtype
            });
        }
        return instance.request(param);
    }
}

let httpClient = new AxiosClass();

export { httpClient };
